/* eslint-disable @typescript-eslint/no-explicit-any */
import  { useEffect, useRef } from 'react'
import { JsonEditor } from 'jsoneditor-react'

import 'jsoneditor-react/es/editor.min.css'

export const ControlledJsonEditor = ({ value, onChange }) => {
    const jsonEditorRef = useRef()
    useEffect(
      () => {
            const current = jsonEditorRef.current as any
            const editor = jsonEditorRef && current && current.jsonEditor
            if(editor && value){ editor.update(value) }
        },
        [jsonEditorRef, value]
    )

    return (
      <JsonEditor
          ref={jsonEditorRef}
          value={value}
          onChange={onChange}
      />
    )
}
